import React, { useState, useEffect } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import FileSelectButton from 'components/molecules/FileSelectButton';
import FormTitle from 'components/atoms/Form/FormTitle';
import BodyText from 'components/atoms/BodyText';
import { utilityColor } from 'components/styles';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import PrimaryButton from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import BlockUI from 'components/molecules/BlockUi';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import { useFormik } from 'formik';
import useSaleBudgetImport from './hooks';

const SalesBudgetYearInputImportLayout = () => {
  if (!sessionStorage.getItem('dateSelect')) {
    sessionStorage.setItem('dateSelect', `${new Date().getFullYear()}`);
  }

  const historyRedirect = useHistory();

  const dateSelect = sessionStorage.getItem('dateSelect') || '';
  const destinationOrg = sessionStorage.getItem('destination_org') || '';

  const [selectedYear] = useState(Number(dateSelect));

  const {
    inputValue,
    setUploadFile,
    uploadFile,
    onSubmit,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    handleSubmit,
    blocking,
  } = useSaleBudgetImport();

  const handleClick = () => {
    // eslint-disable-next-line no-restricted-globals
    history.back();
    sessionStorage.setItem('isBack', 'true');
  };

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  useEffect(() => {
    if (roleScreen && roleScreen.available === false) {
      historyRedirect.push('/404');
    }
  }, [historyRedirect, roleScreen]);

  const formik = useFormik({
    initialValues: {
      inputType: '0',
    },
    onSubmit,
  });

  return (
    <div>
      <BlockUI blocking={blocking}>
        <FormContents>
          <FormTitle title="登録するデータ" />
          {/* <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
            }}
          >
            <p>
              会計年度：
              <strong>{`${selectedYear}年`}</strong>
            </p>
            <p>
              組織名：
              <strong>{destinationOrg}</strong>
            </p>
          </div> */}

          <FormTitle title="月次予算・日次予算のいずれかを選択し、正しい形式のファイルをアップロードしてください。" />

          <FormField>
            <RadioSelectForm
              name="inputType"
              items={[
                {
                  label: '月次予算',
                  value: '0',
                },
                {
                  label: '日次予算',
                  value: '1',
                },
              ]}
              value={formik.values.inputType}
              setValue={formik.handleChange}
            />
          </FormField>

          <FormField>
            <FileSelectButton
              text="CSVファイルをドラッグ＆ドロップ または クリックしてファイルを選択してください"
              ghost={true}
              setFile={setUploadFile}
              value={inputValue}
              accept=".csv"
            />
          </FormField>
          {uploadFile || errors ? (
            <FormField displayBlock={true}>
              <div>{uploadFile?.name}</div>
              {errors &&
                errors.map((error) => (
                  <div key={error}>
                    <BodyText color={utilityColor.error}>{error}</BodyText>
                  </div>
                ))}
            </FormField>
          ) : null}
          <FormSubmitArea>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
              }}
            >
              {roleScreen && roleScreen.importFlag === 1 && (
                <PrimaryButton text="インポート" onClick={handleSubmit} disabled={!uploadFile} />
              )}

              <PrimaryButton text="戻る" ghost={true} onClick={handleClick} />
            </div>
          </FormSubmitArea>
        </FormContents>
      </BlockUI>

      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="確認メッセージ"
        onSubmit={formik.handleSubmit}
        content="ファイルをアップロードします。よろしいですか？"
        items={[]}
      />
    </div>
  );
};
export default SalesBudgetYearInputImportLayout;
